<template>
<section class="layout-pt-lg layout-pb-lg" :style="`background-color: var(--c-${vars.backgroundColor})`" >
  <BlockSymbol :position-text="String(vars?.blockPositionText || '')" :block-color="String(vars?.blockColor || '')" />
      <div class="container">
        <!-- Header with logo and "View All Blogs" button -->
        <div class="row mb-60">
          <div v-html="vars.titleHtml" class="col-lg-8" />
          <div class="col-lg-4 text-right">
            <button class="n-primary tw-mt-4 !tw-justify-start">
        EXPLORE ALL BLOGS
        <span class="btn-arrow"> </span>
      </button>
          </div>
        </div>
    
        <div class="row y-gap-60">
          <!-- Main Column - Featured Blog Posts -->
          <div class="col-lg-8">
            <div class="row y-gap-60">
              <!-- Featured Blog Post (Large) -->
              <div data-anim="slide-up delay-1" class="col-12">
                <div class="ratio ratio-93:60">
                  <img src="" alt="How long does it take to sell a home" class="img-ratio">
                </div>
    
                <div class="mt-20">
                  <h2 class="text-white text-32 uppercase fw-600">HOW LONG DOES IT TAKE TO SELL A HOME IN BURTON-ON-TRENT?</h2>
                  <p class="text-white mt-10">If you're a Burton-on-Trent homeowner, have you ever wondered how long it really takes to sell a home in our town? Whether it's a detached house, semi-detached, terraced, or a flat, the time to...</p>
                  <button class="n-primary tw-mt-4 !tw-justify-start">
        VIEW MORE
        <span class="btn-arrow"> </span>
      </button>
                </div>
              </div>
            </div>
    
            <div class="flex flex-col mt-4">
  <h2 class="text-white text-36 uppercase fw-600">{{ vars.titleText }}</h2>
  
  <div class="flex flex-col mt-30">
    <nuxt-link
      v-for="(button, index) in buttons"
      :key="`takeaction-button-${index}`"
      :to="button.link"
      :class="`n-${button.type} tw-w-full md:tw-w-auto`"
    >{{ button.label }}</nuxt-link>
  </div>

</div>
          </div>
    
          <!-- Sidebar Column -->
          <div class="col-lg-4">
            <!-- Blog Card 1 -->
            <div data-anim="slide-up delay-1" class="mb-40">
              <div class="ratio ratio-93:60">
                <img src="" alt="Stamp duty article" class="img-ratio">
              </div>
              <div class="mt-20">
                <h3 class="text-white text-24 uppercase fw-600">THE NEW STAMP DUTY INCREASE: IS IT REALLY A GAME-CHANGER?</h3>
                <p class="text-white mt-10">The latest increase in stamp duty – raising the surcharge from 3% to 5% for buy-to-let properties – feels like yet another layer of financial burden. However, while this news has many owners very downcast, it's...</p>
                <button class="n-primary tw-mt-4 !tw-justify-start">
        VIEW MORE
        <span class="btn-arrow"> </span>
      </button>
              </div>
            </div>
    
            <!-- Blog Card 2 -->
            <div data-anim="slide-up delay-2" class="mb-40">
              <div class="ratio ratio-93:60">
                <img src="" alt="Renters rights article" class="img-ratio">
              </div>
              <div class="mt-20">
                <h3 class="text-white text-24 uppercase fw-600">ACT NOW: THE RENTERS RIGHTS BILL MOVES CLOSER TO BECOMING LAW</h3>
                <p class="text-white mt-10">Major changes are coming with the Renters' Rights Bill which is expected to become law by Spring 2024. With the next key stage set for January 15th, landlords can't really afford to wait. Acting now...</p>
                <button class="n-primary tw-mt-4 !tw-justify-start">
        VIEW MORE
        <span class="btn-arrow"> </span>
      </button>
              </div>
            </div>
    
            
          </div>
        </div>
      </div>
    </section>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import type { Component } from '~/types';
import indexGlobal from '~/mixins/index.global';
import { BlogsMixin } from '~/units/blogs/mixins/blogs.mixin';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useBlogsStore } from '~/units/blogs/store';
import { useWebsiteStore } from '~/units/website/store';
import { ROUTES } from '~/constants/ui.constants';
import Loader from '~/components/common/Loader.vue';
import BlockSymbol from '~/components/common/BlockSymbol.vue';
export default defineNuxtComponent({
  name: 'Theme7BlogsBox',

  mixins: [BlogsMixin, indexGlobal, ComponentMixin],

  components: {
    Loader,
    BlockSymbol,
  },

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,

      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  async setup(props: { component: Component }) {
    const blogsStore = useBlogsStore();
    await blogsStore.fetchBlogsInPage(props.component);
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),
    ROUTES() {
      return ROUTES;
    },
    cards() {
      return this.groupedVariables.cards;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
    
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },
  mounted() {
    this.onSlideChange();
  },
});
</script>
<style scoped>
.block {
  font-size: 32rem !important;
  font-weight: 700 !important;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: -1;
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: 0 !important;
  left: -80px !important;
}
</style>
